import React, { useState } from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const TIER_OPTIONS = ['Inner Circle', 'Acquaintance', 'Following'];

const BulkActionsFooter = ({ selectedCount, onClear, onBulkUpdateTier }) => {
    const { t } = useTranslation();
    const [showTierMenu, setShowTierMenu] = useState(false);

    if (selectedCount === 0) return null;

    const handleTierSelect = (tier) => {
        onBulkUpdateTier(tier);
        setShowTierMenu(false);
    }

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-gray-900/80 backdrop-blur-md border-t border-gray-700 z-40 animate-fadeInUp a-short-delay">
            <div className="max-w-5xl mx-auto px-4 py-3 flex justify-between items-center">
                <div className="flex items-center gap-4">
                    <button onClick={onClear} className="text-sm font-semibold text-gray-300 hover:text-white flex items-center gap-2">
                        <LucideIcons.XCircle size={20} />
                        <span>{t('bulkActionsFooter.selected', { count: selectedCount })}</span>
                    </button>
                </div>
                <div className="relative">
                    <button 
                        onClick={() => setShowTierMenu(prev => !prev)} 
                        className="flex items-center gap-2 text-sm font-semibold bg-cyan-600 text-white px-4 py-2 rounded-lg hover:bg-cyan-700"
                    >
                        <LucideIcons.Tags size={16} />
                        <span>{t('bulkActionsFooter.addToTier')}</span>
                    </button>
                    {showTierMenu && (
                        <div className="absolute bottom-full right-0 mb-2 w-56 bg-gray-800 border border-gray-700 rounded-lg shadow-lg p-2">
                            {TIER_OPTIONS.map(tier => (
                                <button
                                    key={tier}
                                    onClick={() => handleTierSelect(tier)}
                                    className="w-full text-left flex items-center gap-2 px-2 py-1.5 text-sm text-white rounded-md hover:bg-gray-700/80"
                                >
                                    <LucideIcons.Tag size={16} />
                                    {t(`bulkActionsFooter.tiers.${tier.toLowerCase().replace(' ', '_')}`)}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BulkActionsFooter;
